module.exports = __webpack_public_path__ + "img/5-map.c38c5b82.jpg";